
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'events-and-actions',
	title: 'Overview'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "api-reference/events-and-actions",
  "id": "api-reference/events-and-actions",
  "isDocsHomePage": false,
  "title": "Overview",
  "description": "A product in IOI can have many purposes.  Sometimes, a product is just a set of questions with the",
  "source": "@site/docs/api-reference/events-and-actions.md",
  "sourceDirName": "api-reference",
  "slug": "/api-reference/events-and-actions",
  "permalink": "/docs/api-reference/events-and-actions",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "events-and-actions",
    "title": "Overview"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Rules",
    "permalink": "/docs/api-reference/rules"
  },
  "next": {
    "title": "Firing an Event",
    "permalink": "/docs/api-reference/fire-event"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [{
  value: 'What is an event?',
  id: 'what-is-an-event',
  children: []
}, {
  value: 'What is an action?',
  id: 'what-is-an-action',
  children: []
}, {
  value: 'How are events and actions added to the product?',
  id: 'how-are-events-and-actions-added-to-the-product',
  children: []
}, {
  value: 'How are events fired?',
  id: 'how-are-events-fired',
  children: [{
    value: 'Firing a event in a Storefront and CoPilot',
    id: 'firing-a-event-in-a-storefront-and-copilot',
    children: []
  }, {
    value: 'Firing a event via API',
    id: 'firing-a-event-via-api',
    children: []
  }]
}];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`A product in IOI can have many purposes.  Sometimes, a product is just a set of questions with the
purpose of collecting data.  Other times, a product may do many other things - for example, sell and issue a
policy to the client.  It can also be a bundle with many purposes all built and mixed together.`}</p>
    <p>{`Basically, you can use your imagination when it comes to how you want to use your product.`}</p>
    <p>{`To accommodate this variety, Events and Actions provide the means.`}</p>
    <h2 {...{
      "id": "what-is-an-event"
    }}>{`What is an event?`}</h2>
    <p>{`During and after user interaction with a product (answering of the questions), a
variety of options can be presented to the user.  For example, a user could have an option
to: save their progress, request contact by 3rd party, request a quote or purchase coverage.`}</p>
    <p>{`These options are called `}<strong parentName="p">{`Events`}</strong>{`, and when a user initiate an event,
we refer to that as `}<strong parentName="p">{`Firing an event`}</strong>{`.`}</p>
    <h2 {...{
      "id": "what-is-an-action"
    }}>{`What is an action?`}</h2>
    <p>{`After an event has been fired, any number of things can happen.  Each of those "things" that
happen is called an `}<strong parentName="p">{`Action`}</strong>{`.`}</p>
    <p>{`Actions can perform a variety of tasks.  For example, there's an action that will: Map client intake
to a PDF document and send it via email to address(es) you specify.  Some actions will take a
payload of data collected and send it to some remote web-endpoint.`}</p>
    <p><strong parentName="p"><em parentName="strong">{`Pro tip: `}</em></strong>{` Each event could have multiple, same or different actions.`}</p>
    <h2 {...{
      "id": "how-are-events-and-actions-added-to-the-product"
    }}>{`How are events and actions added to the product?`}</h2>
    <p>{`Events are added to a specific workflow on a product.  To start, select a product and a workflow.
To add a event, click `}<strong parentName="p"><em parentName="strong">{`+ Add new event`}</em></strong>{` link.`}</p>
    <p>{`Each event can be added only once in a workflow.  Otherwise, it would not make much sense
to, for example, add "Get Quote" event twice.  You can however add any number of actions
to that event.`}</p>
    <p>{`Once a event is added and selected, to the right of it you can click
`}<strong parentName="p"><em parentName="strong">{`+ Add new action`}</em></strong>{` to add a new action.`}</p>
    <h2 {...{
      "id": "how-are-events-fired"
    }}>{`How are events fired?`}</h2>
    <p>{`Events may be fired either programmatically via API, or from one of the IOI products.`}</p>
    <h3 {...{
      "id": "firing-a-event-in-a-storefront-and-copilot"
    }}>{`Firing a event in a Storefront and CoPilot`}</h3>
    <p>{`Storefronts and CoPilot are pre-defined to look for existence of several events.  Even if
product/event-group defines additional events, they may be ignored as they are not relevant to
the intended use of these products.`}</p>
    <p>{`The simplest example of a event firing in a Storefront/CoPilot is "Get Quotes" button.
When a user clicks this button, a "GET_QUOTES" event payload will be sent
to IOI.  In turn, IOI will look for all workflows available to the user that define a
event "GET_QUOTES".  All actions defined behind those events will be executed. `}</p>
    <h3 {...{
      "id": "firing-a-event-via-api"
    }}>{`Firing a event via API`}</h3>
    <p>{`Events may be fired via API.  Read more in the next section.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
